import { Tooth } from '../../../../graphql/graphql';

interface Props {
	tooth: Tooth;
	isLeftSide: boolean;
	toothMap: Map<number, Tooth>;
}

const MIDDLE_TEETH_NEIGHBORS: Record<number, number[]> = {
	'11': [12, 21],
	'41': [42, 31],
	'21': [11, 22],
	'31': [41, 32],
};

// teeth are ordered from left to right for upper jaw 18, ..., 11, 21, ..., 28
// and for lower jaw 48, ..., 41, 31, ..., 38
export default function getNeighborTeeth({
	tooth,
	isLeftSide,
	toothMap,
}: Props) {
	if (!(toothMap && tooth.number)) {
		return {
			leftNeighbor: undefined,
			rightNeighbor: undefined,
		};
	}

	const toothNumber = tooth.number;

	let leftNeighborNumber: number = MIDDLE_TEETH_NEIGHBORS[toothNumber]?.[0];
	let rightNeighborNumber: number = MIDDLE_TEETH_NEIGHBORS[toothNumber]?.[1];

	if (!leftNeighborNumber) {
		leftNeighborNumber = isLeftSide ? toothNumber + 1 : toothNumber - 1;
		rightNeighborNumber = isLeftSide ? toothNumber - 1 : toothNumber + 1;
	}

	return {
		leftNeighbor: toothMap.get(leftNeighborNumber),
		rightNeighbor: toothMap.get(rightNeighborNumber),
	};
}
